import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../app.settings';
import { BehaviorSubject, Observable } from 'rxjs';
export interface QaItem {
  question: string;
  answer: string;
}

export interface AiExtractResultItem {
  answer: string;
  question: string;
}

export interface QueryAnswerPayload {
  client_id: number;
  qid: number;
  answer: string;
  answer_plain: string;
}

/** Full API response */
export interface AiExtractResponse {
  message: string;
  result: AiExtractResultItem[];
}

export interface KbDocumentExists {
  client_id: number;
  type_id: number;
}

export interface RfpTrackerAddPayload {
  company_id: number | null;
  client_id: number | null;
  rfp_name: string;
  request_received_on: string;
  expected_submission_date: string;
  submitted_on: string | null;
  submitted_by: string | null;
}

export interface RfpTrackerEditPayload {
  id: number;
  company_id: number | null;
  rfp_name: string;
  request_received_on: string;
  expected_submission_date: string;
  submitted_on: string | null;
  submitted_by: string | null;
}

interface RefreshAnswer {
  document_id: string; // comma-separated document IDs
  question: string[];
  mode: string;
  client_id: number;
  category_id: number;
  query_type: string;
  qid?: number;
  is_global: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class RfpService {
  libExtractKbsheet = AppSettings.EMAIL_API_ENDPOINT + '/rfp/extract/kbsheet';
  RfptypesUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/types';
  CompanyUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/companies';
  CompanyRelationshipUrl =
    AppSettings.EMAIL_API_ENDPOINT + '/rfp/company_relationship';
  clientUrl = AppSettings.EMAIL_API_ENDPOINT + '/client';
  rfpTrainUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/knowledge-base/upload';
  updateTrainUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/knowledge-base/edit';
  rfpDocumentsUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/kb';
  kbDocumentExistsUrl =
    AppSettings.EMAIL_API_ENDPOINT + '/rfp/category/kb-document-exists';
  excelUploadUrl = AppSettings.EXCEL_ENDPOINT + '/upload_excel';
  excelFillUrl = AppSettings.EXCEL_ENDPOINT + '/fill_data';
  excelDownloadUrl = AppSettings.EXCEL_ENDPOINT + '/download_excel';
  uploadRfpQuestionUrl =
    AppSettings.EMAIL_API_ENDPOINT + '/rfp/upload/question';
  docfilePreviewUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/preview';
  attachmentFile = AppSettings.EMAIL_API_ENDPOINT + '/attachment';
  deleteDocumentUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/document';
  rfpRpoDocumentsUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/documents';
  downloadDocumentUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/download';
  lobconfigUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/lob';
  sicConfigUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/sic';
  sheetsPreviewUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/preview/sheets';
  documentPreviewUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/preview/pdf';
  userListUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'users'}/${'all'}`;
  CurrentUserUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'loggedin_user'}`;
  documentNextStageUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/next_stage';
  refreshAnswerUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/query/refresh';

  libFileuploadUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/upload/question';
  libgetExcelQuestionsUrl =
    AppSettings.EMAIL_API_ENDPOINT + '/rfp/extract/questions';
  libgetExcelAnswerUrl =
    AppSettings.EMAIL_API_ENDPOINT + '/rfp/extract/answers';
  extractAnswerFromAi =
    AppSettings.EMAIL_API_ENDPOINT + '/rfp/extract/ai_answer';
  createRfpUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/create';
  saveAsNewRFPUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/save_as_new';
  updateRFPUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/overwrite';
  docVersionsUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/versions';
  docRFPqaUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/qa';
  docinfoCategoryqaUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/qa/category';
  refineAnswerUrl = AppSettings.EMAIL_API_ENDPOINT + 'rfp/refine/answer';
  excelupdateUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/overwrite/excel';
  excelsavenewUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/save_as_new/excel';
  excelEditTrainUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/kb/edit/excel';
  botSearchQueryUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/query';
  botQueryAllUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/queries';
  botQueryPinAllUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/queries';
  botQueryPinUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/query/pin';
  botQueryUnPinUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/query/unpin';
  botQueryfileGenUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/query';
  botQueryfilePreview =
    AppSettings.EMAIL_API_ENDPOINT + '/rfp/queries/download';
  botQueryfileDeleteUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/query/remove';
  botQueryFeedbackUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/feedback';
  botQueryFeedbackListUrl =
    AppSettings.EMAIL_API_ENDPOINT + '/rfp/feedback/list';
  repositoryMetaupdateUrl =
    AppSettings.EMAIL_API_ENDPOINT + '/rfp/save/metadata';
  extractqaForDocsUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/extract/qa';
  docxSavenewUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/save_as_new/document';
  checkCompanyExist =
    AppSettings.EMAIL_API_ENDPOINT + '/rfp/companies/extract_to_import';
  importExistingCompany =
    AppSettings.EMAIL_API_ENDPOINT + '/rfp/companies/import';
  missedQaApi = AppSettings.EMAIL_API_ENDPOINT + '/rfp/knowledge-base/missedqa';
  rfpTrackerUrl = AppSettings.EMAIL_API_ENDPOINT + '/rfp/tracker/get_all';
  rfpTrackerAdd = AppSettings.EMAIL_API_ENDPOINT + '/rfp/tracker/add';
  rfpTrackerEdit = AppSettings.EMAIL_API_ENDPOINT + '/rfp/tracker/edit';
  rfpTrackerDelete = AppSettings.EMAIL_API_ENDPOINT + '/rfp/tracker/';
  infosecCreateQABS: BehaviorSubject<any> = new BehaviorSubject({});
  extractedQuestionData: any;
  constructor(private readonly http: HttpClient) {}

  getClient() {
    return this.http.get(this.clientUrl);
  }

  getexcelAnswerFromAi(payload: any) {
    return this.http.post<AiExtractResponse>(this.extractAnswerFromAi, payload);
  }

  extractQaForDocs(payload: {
    client_id: number | null;
    doc_id: number | null;
  }) {
    return this.http.post<QaItem[]>(this.extractqaForDocsUrl, payload);
  }

  saveNewQADocx(payLoad: any) {
    return this.http.post(this.docxSavenewUrl, payLoad);
  }

  getRFPtypes(company_id: any) {
    return this.http.get(this.RfptypesUrl + '/' + company_id);
  }
  getRFPtypesAll() {
    return this.http.get(this.RfptypesUrl);
  }

  getRFPtype(rfpId: any) {
    return this.http.get(this.RfptypesUrl + '/' + rfpId);
  }

  createRFPtypes(payload: any) {
    return this.http.post(this.RfptypesUrl, payload);
  }
  updateRFPtypes(payload: any, rfpId: any) {
    return this.http.put(this.RfptypesUrl + '/' + rfpId, payload);
  }
  deleteRFPtypes(rfpid: any) {
    return this.http.delete(this.RfptypesUrl + '/' + rfpid);
  }

  getCompanies() {
    return this.http.get(this.CompanyUrl);
  }

  createCompanies(payload: any) {
    return this.http.post(this.CompanyUrl, payload);
  }
  updateCompanies(payload: any, id: any) {
    return this.http.put(this.CompanyUrl + '/' + id, payload);
  }
  deleteCompanies(id: any) {
    return this.http.delete(this.CompanyUrl + '/' + id);
  }

  getCompanyRelationship() {
    return this.http.get(this.CompanyRelationshipUrl);
  }

  createCompanyRelationship(payload: any) {
    return this.http.post(this.CompanyRelationshipUrl, payload);
  }
  updateCompanyRelationship(payload: any, id: any) {
    return this.http.put(this.CompanyRelationshipUrl + '/' + id, payload);
  }
  deleteCompanyRelationship(id: any) {
    return this.http.delete(this.CompanyRelationshipUrl + '/' + id);
  }

  getLob() {
    return this.http.get(this.lobconfigUrl);
  }

  createLob(payload: any) {
    return this.http.post(this.lobconfigUrl, payload);
  }
  updateLob(payload: any, id: any) {
    return this.http.put(this.lobconfigUrl + '/' + id, payload);
  }
  deleteLob(id: any) {
    return this.http.delete(this.lobconfigUrl + '/' + id);
  }

  getSICCode() {
    return this.http.get(this.sicConfigUrl);
  }

  createSICCode(payload: any) {
    return this.http.post(this.sicConfigUrl, payload);
  }
  updateSICCode(payload: any, id: any) {
    return this.http.put(this.sicConfigUrl + '/' + id, payload);
  }
  deleteSICCode(id: any) {
    return this.http.delete(this.sicConfigUrl + '/' + id);
  }

  trainRFPmodel(payload: any) {
    return this.http.post(this.rfpTrainUrl, payload);
  }

  updateTrainModel(payload: any) {
    return this.http.post(this.updateTrainUrl, payload);
  }

  getRFPDocuments(payload: any) {
    return this.http.post(this.rfpDocumentsUrl, payload);
  }

  kbDocumentExists(payLoad: KbDocumentExists) {
    return this.http.post(this.kbDocumentExistsUrl, payLoad);
  }

  uploadxls(payload: any) {
    return this.http.post(this.libFileuploadUrl, payload);
  }

  fillxls(payload: any) {
    return this.http.post(this.excelFillUrl, payload);
  }

  downloadSheet(payload: any) {
    return this.http.post(this.excelDownloadUrl, payload, {
      responseType: 'blob',
    });
  }

  postRFPQuestions(payload: any) {
    return this.http.post(this.uploadRfpQuestionUrl, payload);
  }

  getDocPreview(document_id: any) {
    return this.http.get(this.docfilePreviewUrl + '/' + document_id, {
      responseType: 'blob',
    });
  }
  getExcelPreview(document_id: any) {
    return this.http.get(this.docfilePreviewUrl + '/' + document_id);
  }

  getDocumentPreview(document_id: any) {
    return this.http.get(this.documentPreviewUrl + '/' + document_id, {
      responseType: 'blob',
    });
  }

  getSheetsPrview(document_id: any) {
    return this.http.get(this.sheetsPreviewUrl + '/' + document_id);
  }

  deleteTrainedDocument(document_id: any) {
    return this.http.delete(this.deleteDocumentUrl + '/' + document_id);
  }

  getUserList(payload: any) {
    return this.http.post(this.userListUrl, payload);
  }

  getexcelQuestions(payload: any) {
    return this.http.post(this.libgetExcelQuestionsUrl, payload);
  }

  getexcelAnswers(payload: any) {
    return this.http.post(this.libgetExcelAnswerUrl, payload);
  }

  generateRFP(payload: any) {
    return this.http.post(this.createRfpUrl, payload);
  }

  getRFPRepoDocuments(payload: any) {
    return this.http.post(this.rfpRpoDocumentsUrl, payload);
  }

  deleteRFPDocument(id: any) {
    return this.http.delete(this.deleteDocumentUrl + '/' + id);
  }

  saveAsRFP(payload: any) {
    return this.http.post(this.saveAsNewRFPUrl, payload);
  }
  updateRFPDoc(payload: any) {
    return this.http.post(this.updateRFPUrl, payload);
  }

  getVersionById(Id: any) {
    return this.http.get(this.docVersionsUrl + '/' + Id);
  }

  getRFPqaById(Id: any) {
    return this.http.get(this.docRFPqaUrl + '/' + Id);
  }

  getInfoqaByCateId(Id: any) {
    return this.http.get(this.docinfoCategoryqaUrl + '/' + Id);
  }

  savefileDownload(Id: any) {
    return this.http.get(this.downloadDocumentUrl + '/' + Id, {
      responseType: 'blob',
    });
  }

  saveQAedit(payLoad: any) {
    return this.http.post(this.excelupdateUrl, payLoad);
  }

  saveNewQA(payLoad: any) {
    return this.http.post(this.excelsavenewUrl, payLoad);
  }

  editExcelTrain(payLoad: any) {
    return this.http.post(this.excelEditTrainUrl, payLoad);
  }

  getCurrentUser() {
    return this.http.get(this.CurrentUserUrl);
  }

  documentNextStage(document_id: any) {
    return this.http.post(this.documentNextStageUrl + '/' + document_id, {});
  }
  getdocumentPreview(document_id: any) {
    let id = document_id;
    return this.http.get(this.documentPreviewUrl + '/' + id, {
      responseType: 'blob',
    });
  }

  searchBotQuery(payLoad: any) {
    return this.http.post(this.botSearchQueryUrl, payLoad);
  }

  getBotQueryAll(payload: any) {
    return this.http.post(this.botQueryAllUrl, payload);
  }

  botQueryDelete(query_id: any) {
    return this.http.delete(this.botSearchQueryUrl + '/' + query_id);
  }

  getBotQueryPinAll(payload: any) {
    return this.http.post(this.botQueryPinAllUrl, payload);
  }

  botQueryPin(qid: any) {
    return this.http.put(this.botQueryPinUrl + '/' + qid, {});
  }

  botQueryUnPin(qid: any) {
    return this.http.put(this.botQueryUnPinUrl + '/' + qid, {});
  }

  botQueryGenfile(payload: any) {
    return this.http.put(this.botQueryfileGenUrl, payload);
  }

  botQueryFilePreview(payload: any) {
    return this.http.post(this.botQueryfilePreview, payload, {
      responseType: 'blob',
    });
  }

  botQueryFileDelete(payload: any) {
    return this.http.delete(
      this.botQueryfileDeleteUrl +
        '/' +
        payload['qid'] +
        '/' +
        payload['doc_type'],
    );
  }

  botQueryComment(payload: any) {
    return this.http.post(this.botQueryFeedbackUrl, payload);
  }

  botQueryFeedback(payload: any) {
    return this.http.post(this.botQueryFeedbackListUrl, payload);
  }

  respositoryMetaUpdate(payload: any) {
    return this.http.post(this.repositoryMetaupdateUrl, payload);
  }

  refreshAnswer(payload: RefreshAnswer) {
    return this.http.put(this.refreshAnswerUrl, payload);
  }

  extractKbSheet(payload: any) {
    return this.http.post<any>(this.libExtractKbsheet, payload);
  }

  checkCompanyExists(payload: { company_name: string; client_id: number }) {
    return this.http.post(`${this.checkCompanyExist}`, payload);
  }

  importCompany(payload: {
    company_id: number;
    client_id: number;
  }): Observable<any> {
    return this.http.post(`${this.importExistingCompany}`, payload);
  }

  addMissedQa(payload: any): Observable<any> {
    return this.http.post<any>(this.missedQaApi, payload);
  }

  updateAnswerGlobal(payLoad: QueryAnswerPayload) {
    return this.http.put<any>(this.botSearchQueryUrl, payLoad);
  }

  getAllRfpTracker(payload: {
    page: number;
    limit: number;
    filters: any[];
  }): Observable<any> {
    return this.http.post<any>(this.rfpTrackerUrl, payload);
  }

  addRfpTracker(payload: RfpTrackerAddPayload): Observable<any> {
    return this.http.post(this.rfpTrackerAdd, payload);
  }

  // DELETE api/rfp/tracker/<int:tracker_id>
deleteRfpTracker(trackerId: number): Observable<any> {
  return this.http.delete(`${this.rfpTrackerDelete}${trackerId}`);
}

// PUT api/rfp/tracker/edit
updateRfpTracker(payload: RfpTrackerEditPayload): Observable<any> {
  return this.http.put(`${this.rfpTrackerEdit}`, payload);
}
}
